import { requestGooseAPI, getAPIPath } from '../shared/request'
import { TBookingStep, ReceiptClientDto, CLIENT_RECEIPT_PATH } from '../types'

export const ClientReceiptService = {
  getReceipt: async (locationName: string, orderId: string, step: TBookingStep): Promise<ReceiptClientDto> => {
    return requestGooseAPI<ReceiptClientDto>({
      url: getAPIPath(CLIENT_RECEIPT_PATH, { locationId: locationName, id: orderId }),
      method: 'GET',
      params: {
        step,
      },
    })
  },
}
